import IApiUrlParams from './IApiUrlParams';
import IUrlParams from './IUrlParams';
import IApiJsonUrlParams from './IApiJsonUrlParams';

interface IPars {
  params: IUrlParams;
  doParams: IUrlParams;
  colParams: IUrlParams;
}

const allowedCollectionParams = [
  'perPage',
  'pageNo',
  'sortColumn',
  'sortDirection',
  'textSearchFields',
  'textSearchValue'
];

const UrlBuilder = {
  host: process.env.REACT_APP_API_URL,
  apiUrl: () => `${UrlBuilder.host}/api-v2`,
  getURL: (params: IApiUrlParams) => {
    const urlParts = [
      UrlBuilder.apiUrl(),
      params.handler || 'crud',
      params.dataObjectName || params.action
    ];
    if (
      params.id !== undefined &&
      (params.field === undefined || params.field === 'ID')
    ) {
      urlParts.push(`${params.id}`);
    }

    const url = urlParts.join('/');
    const pars: IPars = { params: {}, doParams: {}, colParams: {} };
    pars.params = { ...params.params };
    if (params.field && params.field !== 'ID' && params.id) {
      pars.params[params.field] = params.id;
    }

    pars.doParams = {
      ...(params.dataObjectParams || {}),
      ...(params.collectionParams?.dataObjectParams || {})
    };

    if (params.collectionParams) {
      Object.entries(params.collectionParams).forEach(([key, val]) => {
        if (allowedCollectionParams.includes(key))
          pars.colParams[`_${key}`] = val;
      });
      if (params.collectionParams.fieldFilters) {
        params.collectionParams.fieldFilters.forEach(
          ({ fieldName, comparison, value }) => {
            const key = `${fieldName}` + (comparison || '');
            pars.colParams[key] = value;
          }
        );
      }
    }
    pars.params = { ...pars.params, ...pars.colParams, ...pars.doParams };

    const paramsString = Object.entries(pars.params)
      .map(([key, val]) => `${key}=${val}`)
      .join('&');

    if (paramsString.length > 0) return [url, paramsString].join('?');

    return url;
  },
  jsonUrl: () => `${UrlBuilder.host}/_api-v2`,
  getJsonURL: (params: IApiJsonUrlParams) =>
    `${UrlBuilder.jsonUrl()}/${params.folder}/${params.file}.json`
};

export default UrlBuilder;
